import script from "./patient-details.vue?vue&type=script&setup=true&lang=js"
export * from "./patient-details.vue?vue&type=script&setup=true&lang=js"

import "./patient-details.vue?vue&type=style&index=0&id=4670bddb&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4670bddb"]])

export default __exports__